// WhatAreOthersWatchingUpdates
//
// 1. Pause live updates while the mouse is over the section
//    (sets phx-update="ignore" on mouseenter, removes on mouseleave).
//
// 2. Animate item transitions using the FLIP technique:
//    - New items fade in
//    - Removed items fade out and collapse
//    - Remaining items slide smoothly to their new position

const ANIMATION_DURATION = 500;

export const WhatAreOthersWatchingUpdates = {
  mounted() {
    // --- hover pause ---
    this.el.addEventListener("mouseenter", () => {
      this.el.setAttribute("phx-update", "ignore");
    });

    this.el.addEventListener("mouseleave", () => {
      this.el.removeAttribute("phx-update");
    });

    // --- FLIP animations ---
    this._snapshotPositions();
  },

  beforeUpdate() {
    this._snapshotPositions();
  },

  updated() {
    this._animateTransition();
  },

  // Record bounding rect of every keyed item
  _snapshotPositions() {
    this._prevRects = new Map();
    for (const el of this.el.querySelectorAll("[data-waow-key]")) {
      this._prevRects.set(el.dataset.waowKey, el.getBoundingClientRect());
    }
    this._prevKeys = new Set(this._prevRects.keys());
  },

  _animateTransition() {
    const items = this.el.querySelectorAll("[data-waow-key]");
    const currentKeys = new Set();

    for (const el of items) {
      const key = el.dataset.waowKey;
      currentKeys.add(key);
      const prev = this._prevRects.get(key);

      if (!prev) {
        // New item — fade in
        el.animate(
          [
            { opacity: 0, transform: "scale(0.95)" },
            { opacity: 1, transform: "scale(1)" },
          ],
          {
            duration: ANIMATION_DURATION,
            easing: "ease-out",
            fill: "backwards",
          },
        );
      } else {
        // Existing item — slide from old position to new
        const curr = el.getBoundingClientRect();
        const dx = prev.left - curr.left;
        const dy = prev.top - curr.top;

        if (dx !== 0 || dy !== 0) {
          el.animate(
            [
              { transform: `translate(${dx}px, ${dy}px)` },
              { transform: "translate(0, 0)" },
            ],
            { duration: ANIMATION_DURATION, easing: "ease-out" },
          );
        }
      }
    }

    // Removed items — we can't animate them since they're already gone from the DOM.
    // LiveView removes them before updated() fires. The FLIP slide of remaining items
    // already makes the removal feel smooth.
  },
};
